import type React from 'react';
import { TrackingPage } from '@/components';

const TrackingOnlinePage: React.FC = () => {
  return <TrackingPage />;
};

export default TrackingOnlinePage;
